import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { filterBy } from "../redux/filter/actions";

export default function Search() {
  const [input, setInput] = useState("");
  const dispatch = useDispatch();
  const timeOutRef = useRef(null);
  const handleChange = (e) => {
    setInput(e.target.value);
    if (timeOutRef.current) {
      clearTimeout(timeOutRef.current);
    }
    timeOutRef.current = setTimeout(() => {
      dispatch(filterBy("search", e.target.value));
      console.log("search =>",e.target.value);
    }, 1000);
  };
  return (
    <div className="border mt-6 border-slate-200 flex items-center w-11/12 lg:w-1/2 mx-auto bg-gray-50 h-12 px-5 rounded-lg text-sm ring-emerald-200">
      <input
        value={input}
        onChange={handleChange}
        className="outline-none border-none bg-gray-50 h-full w-full mr-2"
        type="search"
        name="search"
        placeholder="Search"
      />
      <img
        className="inline h-6 cursor-pointer"
        src="./assets/search.svg"
        alt="Search"
      />
    </div>
  );
}
